module.exports = __webpack_public_path__ + "static/media/FinanceMgmt.8ede8634.svg";